import { Button, Grid, Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { InnerNavigationItem } from "../../types/sidebar";
import BackButton from "./BackButton";

type PageWrapperProps = {
  children: ReactNode;
  title?: string;
  innerNavigationItems?: InnerNavigationItem[];
  hasBackButton?: boolean;
  backButtonTo?: string;
  button?: ReactElement;
};

function PageWrapper(props: PageWrapperProps) {
  return (
    <>
      <Helmet />
      <Grid container spacing={6}>
        <Grid item xs={9}>
          {props.hasBackButton && props.backButtonTo && (
            <BackButton to={props.backButtonTo} />
          )}
          <Typography variant="h2">{props.title}</Typography>
        </Grid>
        {props.button && (
          <Grid item xs={3}>
            {props.button}
          </Grid>
        )}
        <InnerNavigationBar items={props.innerNavigationItems} />
        {props.children}
      </Grid>
    </>
  );
}

type InnerNavigationBarProps = {
  items?: InnerNavigationItem[];
};

export function InnerNavigationBar(props: InnerNavigationBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, workerId } = useParams();

  return (
    <Grid container spacing={6} ml={0} mt={2}>
      <Grid item xs={12} mb={10}>
        {props.items?.map((el) => {
          const url = el.to({
            projectId: projectId,
            workerId: workerId,
          });
          return (
            <Button
              variant={location.pathname === url ? "contained" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => {
                navigate(url);
              }}
              disabled={el.disabled}
            >
              {el.title}
            </Button>
          );
        })}
      </Grid>
    </Grid>
  );
}

export default PageWrapper;
